import { Button, Card, Typography } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import BookingPhotographerModalContent from '../servicesmodal/tasks/BookingPhotographerModalContent';
import ShowSpin from 'components/v2/spin/ShowSpin';
import { useLocalization } from 'localization';
import { useBookingPhotographer } from 'hooks/services/useBookingPhotographer';
import { BookingStatus } from 'api';

const Booking = () => {
  const { t } = useLocalization();
  const { form, actions, apiStates, loading } = useBookingPhotographer();

  const views = () => {
    switch (apiStates?.bookingInformation?.status) {
      case BookingStatus.RECORDED:
        return (
          <>
            <FormProvider {...form}>
              <BookingPhotographerModalContent
                proposals={apiStates.proposalData}
                disabled={false}
                loading={loading.isProposalLoading}
                isGuest
              />
            </FormProvider>
            <Button
              variant="contained"
              loading={loading.isUpdateBookingLoading || loading.isBookingPhotographerLoading}
              onClick={actions.onSubmit}
            >
              {t('common.terms.submit')}
            </Button>
          </>
        );
      case BookingStatus.CONFIRMED:
        return <Typography variant="subtitle1">{t('orders.pages.bookOnline.taskCompletedTitle')}</Typography>;
      default:
        return <Typography variant="subtitle1">{t('common.messages.resourceNotFound')}</Typography>;
    }
  };

  return (
    <Card sx={{ mt: 20, mb: 20, justifyContent: 'center' }}>
      <Typography variant="h4">{t('tasks.categories.BOOK_PHOTOGRAPHER')}</Typography>
      <ShowSpin when={loading.isProposalLoading || loading.isTaskFetching}>{views()}</ShowSpin>
    </Card>
  );
};

export default Booking;
